export default __webpack_public_path__ + "static/media/classic4.f8f6546c.jpg";